export enum MstColorLogic {
  ASSET_CLASS = 'colorAssetClass',
  FACTOR = 'colorFactor',
  PINNED = 'colorPinned',
  LABELS = 'colorLabels',
}

export const MST_COLOR_OPTIONS = Object.values(MstColorLogic);
